import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { reel, poster, REEL_GROUPS } from "@/lib/media";

const ReelCard = ({ group }) => {
    const ref = useRef(null);
    const [playing, setPlaying] = useState(false);

    const enter = () => {
        if (ref.current) {
            ref.current.play().then(() => setPlaying(true)).catch(() => {});
        }
    };
    const leave = () => {
        if (ref.current) {
            ref.current.pause();
            ref.current.currentTime = 0;
            setPlaying(false);
        }
    };

    return (
        <div
            data-testid={`reel-${group.key}`}
            className="group relative shrink-0 w-[62%] sm:w-[40%] md:w-[26%] lg:w-[20%] aspect-[9/16] rounded-2xl overflow-hidden bg-verde-900 shadow-soft"
            onMouseEnter={enter}
            onMouseLeave={leave}
            onClick={enter}
        >
            <video
                ref={ref}
                src={reel(group.key)}
                poster={poster(group.key)}
                muted
                loop
                playsInline
                preload="none"
                className="w-full h-full object-cover"
            />
            <div className={`absolute inset-0 bg-gradient-to-t from-black/60 to-transparent transition-opacity ${playing ? "opacity-40" : "opacity-100"}`} />
            {!playing && (
                <div className="absolute inset-0 flex items-center justify-center">
                    <span className="h-14 w-14 rounded-full bg-white/90 flex items-center justify-center">
                        <Play size={22} className="text-verde ml-1" fill="currentColor" />
                    </span>
                </div>
            )}
            <p className="absolute bottom-4 left-4 right-4 text-white font-display font-semibold text-sm leading-tight">{group.label}</p>
        </div>
    );
};

export const ReelGallery = () => {
    return (
        <div className="overflow-x-auto pb-4 -mx-4 px-4 sm:mx-0 sm:px-0" data-testid="reel-gallery">
            <div className="flex gap-4">
                {REEL_GROUPS.map((g) => <ReelCard key={g.key} group={g} />)}
            </div>
        </div>
    );
};
